import { StandardEvents } from '@shopify/events';

/**
 * Keeps a variant-scoped description in sync with the selected variant.
 *
 * The variant picker fetches the re-rendered section on every change and hands
 * the markup to listeners via the product select event; we pick our own block
 * out of it and swap the contents in. Mirrors how `product-price.js` works.
 */
class VariantDescription extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {CustomEvent & { promise: Promise<{ detail: any }> }} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newDescription = html.querySelector(`variant-description[data-block-id="${this.dataset.blockId}"]`);
        if (!newDescription) return;

        this.innerHTML = newDescription.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[variant-description] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('variant-description')) {
  customElements.define('variant-description', VariantDescription);
}
